export { PLUGIN_KEY, PLUGIN_PRIORITY, ManualRowResize } from "./manualRowResize.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/manualRowResize/index.mjs
// module id = 1476
// module chunks = 1